// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__3sedR","form":"styles_form__2ZO14"};